export default {

  layout: JSON.parse(localStorage.getItem("flyvendas:layoutData"))

}
